<empathy-preview-wrapper>
  <empathy-end-page-view [endPage]="endPage$()"></empathy-end-page-view>
</empathy-preview-wrapper>
